<div class="row">
  
  <div class="col col-md-8">
    <h5><b>Consultar comprobantes de pago</b></h5>
  </div>
  <div class="col-md-4 text-right" *ngIf="request.canModifyReceipts(_auth.user)">
    <input
      *ngIf="request.receipts?.length != maxReceipts "
      type="file"
      name="file"
      class="pointer"
      id="upload-file"
      #fileInput
      (click)="fileInput.value = null"
      (change)="onFileSelected($event.target.files[0])"
    />
    <label for="upload-file">
      <h5 (click)="checkMaxReceipts()" class="primary upload-receipt pointer">
        <img src="assets/images/requests/upload.png" alt="Adjuntar pdf" />
        <b>Adjuntar comprobante</b>
      </h5>
    </label>

  </div>
</div>
<hr />
<table class="table table-striped fadeIn fast">
  <tbody>
    <tr *ngFor="let receipt of request.receipts, let i = index">
      <td class="col-md-1 col-pdf">
        <div class="pdf">
          <img class="text-center" src="assets/images/requests/icn-pdf.png" />
        </div>
      </td>
      <td class="col-md-2">
        <label class="col-title">Nombre</label>
        <label>{{ receipt.name }}</label>
      </td>
      <td class="col-md-1">
        <label class="col-title">Nº comprobante</label>
        <label>{{ i + 1 }}</label>
      </td>
      <td class="col-md-2">
        <label class="col-title">Nº operación</label>
        <label>{{ receipt.operationNumber }}</label>
      </td>
      <td class="col-md-1">
        <label class="col-title">Moneda</label>
        <label>{{ receipt.currency }}</label>
      </td>
      <td class="col-md-1">
        <label class="col-title">Monto</label>
        <label>{{ receipt.amount | currency:'':'' | customCurrency:receipt.currency  }}</label>
      </td>
      <td class="col-md-2">
        <a (click)="_modal.show('SHOW', receipt, request)"
          ><label class="lighter-green pointer text-center"
            >Ver comprobante</label
          ></a
        >
      </td>
      <td *ngIf="request.canModifyReceipts(_auth.user)" class="col-md-1">
        <div class="row actions">
          <div class="col-sm-12 col-md-6">
            
            <img class="pointer" (click)="_modal.show('EDIT', receipt, request)" src="assets/images/pages/edit.png" />
          </div>
          <div class="col-sm-12 col-md-6">
            <img
              (click)="delete(receipt)"
              class="pointer"
              src="assets/images/pages/delete.png"
            />
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
